import PropTypes from 'prop-types';

import { Box } from '@mui/material';

const IconGeofencingIssues = (props) => {
  // Retirer explicitement la prop 'filled' pour éviter de la propager au composant MUI "Box" qui ne l'accepte pas
  const { filled, fontSize = '1.5rem', color = 'text.disabled', ...other } = props;
  // Extraction de la prop 'filled' et avertir eslint que la variable n'est pas utilisée grâce à l'opérateur 'void' de eslint
  void filled;

  return (
    <Box component="span" display="block" height={fontSize} width={fontSize} {...other}>
      <svg id="geofencing_issues" width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          id="geofencing_issues_earth"
          fill={color || '#000000'}
          d="M11.9,22c-1.4,0-2.7-0.3-3.9-0.8c-1.2-0.5-2.3-1.2-3.2-2.1
          s-1.6-2-2.1-3.2c-0.5-1.2-0.8-2.5-0.8-3.9s0.3-2.7,0.8-3.9C3.3,6.9,4,5.8,4.9,4.9s2-1.6,3.2-2.1C9.3,2.2,10.6,2,11.9,2
          c2.4,0,4.6,0.8,6.4,2.3c1.8,1.5,3,3.4,3.4,5.7h-2c-0.3-1.2-0.9-2.3-1.7-3.3c-0.8-1-1.8-1.7-3-2.2V5c0,0.5-0.2,1-0.6,1.4
          C14,6.8,13.5,7,12.9,7h-2v2c0,0.3-0.1,0.5-0.3,0.7C10.5,9.9,10.2,10,9.9,10h-2v2h2v3h-1l-4.8-4.8c0,0.3-0.1,0.6-0.1,0.9
          c0,0.3-0.1,0.6-0.1,0.9c0,2.2,0.8,4.1,2.3,5.6S9.7,20,11.9,20V22z"
        />
        <path
          id="geofencing_issues_exclamation_mark"
          fill={color || '#000000'}
          d="M16.6 21.4c.3 0 .5-.1.6-.3.2-.2.3-.4.3-.6s-.1-.5-.3-.6c-.2-.2-.4-.3-.6-.3-.3 0-.5.1-.6.3-.2.2-.3.4-.3.6 0 .3.1.5.3.6.1.3.3.3.6.3zm-.9-3.3h1.8v-6.8h-1.8v6.8z"
        />
      </svg>
    </Box>
  );
};

IconGeofencingIssues.propTypes = {
  color: PropTypes.string,
  filled: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconGeofencingIssues;
